"use client";
import Image from "next/image";
import drugIcon from "@/assets/drug.svg";
import deliveryIcon from "@/assets/fast.svg";
import healthIcon from "@/assets/heart.svg";
export default function ProductFeaturesSection() {
  const features = [
    {
      icon: (
        <Image
          className="w-[100px]"
          src={deliveryIcon}
          alt="Delivery"
          width={40}
          height={40}
        />
      ),
      title: "Fast, discreet delivery",
      description:
        "Delivered in secure, plain packaging with tracked delivery from just £2.95",
    },
    {
      icon: <Image src={healthIcon} alt="Health" width={40} height={40} />,
      title: "Fully regulated U.K. clinic",
      description:
        "Our team of doctors and pharmacists, and our support staff, are all UK based.",
    },
    {
      icon: <Image src={drugIcon} alt="Drug" width={40} height={40} />,
      title: "Free advice and support",
      description:
        "Have a question? Telephone support is always free; Mon-Friday, 9am -5pm.",
    },
  ];

  return (
    <section className="bg-white py-12 sm:py-16 lg:py-20">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-20 2xl:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-xl p-6 sm:p-8 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex flex-col gap-5">
                {/* Icon */}
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <div className="text-purple-600">{feature.icon}</div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  {/* Title */}
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                    {feature.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
